import { ICasino, ISlot, IStreamer } from 'constants/types';
import { Markdown } from 'common/markdown-components';
import styles from './styles.module.css';
import clsx from 'clsx';

export const Description = ({
  data,
  isSlot,
  className,
  isStreamer,
}: {
  data: ISlot | ICasino | IStreamer;
  isSlot?: boolean;
  isStreamer?: boolean;
  className?: string;
}) => {
  const getName = (item: ISlot | ICasino | IStreamer): string => {
    if ('username' in item) {
      return item.username;
    }
    if ('name' in item) {
      return item.name;
    }
    return '';
  };

  const { description } = data ?? {};
  const name = getName(data);

  return (
    <div className={clsx(styles.container_s, className)}>
      <h2 className={styles.about_info__title}>
        {isSlot && `${name} Slot overview`}
        {isStreamer && (data as IStreamer).titleDescription
          ? (data as IStreamer)?.titleDescription
          : ''}
        {!isSlot && !isStreamer && `${name} overview`}
      </h2>
      <div className={styles.wrapper_description}>
        <Markdown data={description ?? ''} />
      </div>
    </div>
  );
};
